module.exports = __webpack_public_path__ + "static/fipcnavyteddy4-c4d52f0a5691d54bbdf1e286be64faf1.jpeg";